module.exports = __webpack_public_path__ + "img/f116861.jpg";